/**
 * Author：brand
 * Creation Time：2019-06-10 11:06
 * Email：brandhuang@qq.com
 */
import ax from '../../axios'

export function getServiceListAPI (params) {
  return ax({
    url: '/wlapi/csmanage/cserviceList',
    method: 'POST',
    params,
  })
}
export function getServiceTypeListAPI (params) {
  return ax({
    url: '/wlapi/csmanage/cstypeList',
    method: 'POST',
    params,
  })
}

export function addChildServiceAPI (params) {
  return ax({
    url: '/wlapi/csmanage/addCservice',
    method: 'POST',
    params,
  })
}
export function editChildServiceAPI (params) {
  return ax({
    url: '/wlapi/csmanage/editCservice',
    method: 'POST',
    params,
  })
}

export function delChildServiceAPI (params) {
  return ax({
    url: '/wlapi/csmanage/delCservice',
    method: 'POST',
    params,
  })
}

export function getChildServiceDataAPI (params) {
  return ax({
    url: '/wlapi/csmanage/editCservicePage',
    method: 'POST',
    params,
  })
}

export function offlineChildServiceAPI (params) {
  return ax({
    url: '/wlapi/mySetPage/csOffline',
    method: 'POST',
    params,
  })
}

export function changeChildServiceStatusAPI (params) {
  return ax({
    url: '/wlapi/mySetPage/changeCsStatus',
    method: 'POST',
    params,
  })
}
